// extracted by mini-css-extract-plugin
module.exports = {"sy64n8u":"sy64n8u","n1lymyo5":"n1lymyo5"};